import { GeoPoint } from 'firebase/firestore'
import { firestoreTimestampToDate, isDate, isFirebaseTimestamp } from '../utils/obejct-diff'
import { Context, ContextMembership } from './context.data'
import { NetworkConstants } from './network.constants'

export interface IshowSubFormGR {
    subForm?:string
    data?:any
}

export interface IGameRecord {
    identifier: string
    contextId: string
    wildart: string
    gender: string
    age: string
    tagid?: string
    officialGameTag?: string
    timeStamp: Date
    updateTimestamp?: Date
    creationDate: Date
    huntingDistrictId: string
    huntingDistrictName: string
    huntingDistrictAdministrativeName: string
    ageInYears: string
    placeOfKilling: GameLocation
    placeOfKillingLatitude:Number
    placeOfKillingLongitude:Number
    // species: string
    gameCollectStationId?: string
    gameCollectStationName?: string
    weights?: GameWeights
    erlegerId: string
    hunterLocation: GameLocation
    erlegeArt?: string
    erlegeArtTitel?: string
    eventId?: string
    eventName?: string
    plannedUtilization?: string
    shotQuality?: string
    meatQuality?: string
    comment?: string
    anteMortemInspectionComments?: string
    postMortemInspectionRequired?: boolean
    postMortemInspectionComment?: string
    unbekanntZuvorBeschossen?: boolean
    hasShootPrice?: boolean
    shootPrice?: number
    receiptNo?: string
    captureLocation?: GameLocation
    currentLocation?: GameLocation
    createdByUserId?:string
    createdByUserName?:string
    status: string,
    currentLocationID: string
    erlegerAnzeigeName?: string
    gameCount?: number
    locationCoordinates?: GeoPoint
    imageCount?: number
    officialGameTagName?: string
    hiTierState?: string
    hiTierResult?: any
    extra?: any
    gameOriginFormData?: any
    veterinarianOffice?: string
    huntingOffice?: string
    hiTierGameOriginLink?: string
    pictureURLlinks?:string
    webTSNobject?:string
    // quality?:string
    // rating?: string
    laboratorySamples?:ILabSampleGR[]
}

export interface ILabSampleGRExaminations {
    approvalTimestamp?:Date
    checkDate?: Date
    examinationDisease?: string
    examinationMethod?: string
    examinationOrder?: string
    examinationStatus?: string
    examinerName?: string
    laboratoryAddress1?: string
    laboratoryCity?: string
    laboratoryEmail?: string
    laboratoryName?: string
    laboratoryPhone?: string
    laboratoryZip?: string
    laboratoryContact?: string
    receiptDate?: Date
    result?: string
    resultValue?: string
    veterinaryContact?: string
}

export interface ILabSampleGR{
    id: string
    type: string
    state?: string
    hiTierState?: string
    nvState?: string
    error?: string
    errorCode?: string
    hiTierError?:string
    hiTierErrorCode?:string
    examinations?:ILabSampleGRExaminations[]
}

export interface GameLocation {
    name?: string
    id?: string
    location?: GeoPoint
    comment?: string
    ags?: string
}

export interface GameWeights {
    dressedPreliminary?: number
    salesAsWholeBody?: number
}

enum GameRecordGender {
    MALE = "M", FEMALE = "F"
}

export const DefaultSpeciesIcons = [
    "DIWIMA_Icons_Wildarten_Dachs",
    "DIWIMA_Icons_Wildarten_Waschbaer",
    "icnDamwild",
    "icnFuchs",
    "icnMuffelwild",
    "icnRehwild",
    "icnRotwild",
    "icnSchwarzwild",
    "icnSikawild",
    "icnNutria",
    "icnCwd",
    "icnMuntjac"
]

export const statusColorsLabSampleGR = [
    {
        type:"receivedResult",
        color:"white",
        sort: 3
    },
    {
        type:"pendingSubmission",
        color:"rgba(255,255,0,0.3)",//yellow
        sort: 2
    },
    {
        type:"pendingResults",
        color:"rgba(255,255,0,0.3)",//yellow
        sort: 2
    },
    {
        type:"certificatePending",
        color:"rgba(255,255,0,0.3)",//yellow
        sort: 2
    },
    {
        type:"skippedSubmission",
        color:"rgba(255, 0, 0, 0.6)",//red
        sort: 1
    },
    {
        type:"submissionFailed",
        color:"rgba(255, 0, 0, 0.6)",//red
        sort: 1

    },
    {
        type:"certificateFailed",
        color:"rgba(255, 0, 0, 0.6)",//red
        sort: 1
    },
    {
        type:"authenticationFailed",
        color:"rgba(255, 0, 0, 0.6)",//red
        sort: 1

    },
    {
        type:"sampleRejected",
        color:"rgba(255, 0, 0, 0.6)",//red
        sort: 1

    },
    {
        type:"certificateCreated",
        color:"white",
        sort: 3
    }

]

export const colorLabSamopleStatusGR = {
    red:["skippedSubmission", "submissionFailed", "certificateFailed", "authenticationFailed", "sampleRejected"],
    yellow:["pendingSubmission", "pendingResult", "certificatePending"],
    white:["receivedResult","certificateCreated"]
}

export class GameRecord {

    public static className = "GameRecord"
    public className = "GameRecord"

    identifier: string|undefined = undefined
    contextId: string|undefined = undefined
    contextIds: string[]|undefined = undefined
    contextIdRights: {[contextId: string]: 'view'|'update'}|undefined = undefined
    wildart: string|undefined = undefined
    gender: string|undefined = undefined
    age: string|undefined = undefined
    tagid: string|undefined = undefined
    officialGameTag: string|undefined = undefined
    timeStamp: Date|undefined = undefined
    huntingDistrictId: string|undefined = undefined
    huntingDistrictName: string|undefined = undefined
    huntingDistrictAdministrativeName: string|undefined = undefined
    ageInYears: string|undefined = undefined
    placeOfKilling: GameLocation|undefined = undefined
    placeOfKillingLatitude: Number| undefined = undefined
    placeOfKillingLongitude: Number| undefined = undefined
    gameCollectStationId: string|undefined = undefined
    gameCollectStationName: string|undefined = undefined  // new 
    weights: GameWeights|undefined = undefined
    erlegerId: string|undefined = undefined
    erlegerAnzeigeName: string|undefined = undefined  // new
    hunterLocation: GameLocation|undefined = undefined
    erlegeArt: string|undefined = undefined
    erlegeArtTitle: string|undefined = undefined // new
    eventId: string|undefined = undefined
    eventName: string|undefined = undefined // new
    shotQuality: string|undefined = undefined
    shotQualityTitle: string|undefined = undefined  // new
    meatQuality: string|undefined = undefined
    meatQualityTitle: string|undefined = undefined  // new
    comment: string|undefined = undefined
    anteMortemInspectionComments: string|undefined = undefined
    postMortemInspectionRequired: boolean|undefined = undefined
    postMortemInspectionComment: string|undefined = undefined
    unbekanntZuvorBeschossen: boolean|undefined = undefined
    hasShootPrice: boolean|undefined = undefined
    shootPrice: number|undefined = undefined
    receiptNo: string|undefined = undefined
    captureLocation: GameLocation|undefined = undefined
    currentLocation: GameLocation|undefined = undefined
    status: string|undefined = undefined
    statusTitle: string|undefined = undefined // new
    currentLocationID: string|undefined = undefined
    currentLocationTitle: string|undefined = undefined // new
    gameCount: number|undefined = undefined
    imageCount: number|undefined = undefined
    locationCoordinates: GeoPoint|undefined = undefined
    postingAccount: string|undefined = undefined
    plannedUtilization: string|undefined = undefined
    plannedUtilizationDisplay: string|undefined = undefined // new
    plannedUtilizationDetails: any|undefined = undefined
    updateTimestamp: Date|undefined = undefined
    creationDate: Date|undefined = undefined
    quality: string|undefined = undefined
    hiTierState?: string = undefined
    hiTierResult?: any = undefined
    extra?: any = undefined
    gameOriginFormData: any| undefined = undefined
    veterinarianOffice?: string = undefined
    huntingOffice?: string = undefined
    createdByUserId?:string = undefined
    createdByUserName?:string = undefined
    reportingIds: string[]|undefined
    pictureURLlinks?:string[]|undefined
    reportingImages:boolean|undefined=false
    webTSNobject?:string|undefined = undefined
    laboratorySamples?:ILabSampleGR[] | undefined = undefined
    private context: Context|ContextMembership|undefined = undefined

    constructor(
        associatedContext?: Context|ContextMembership
    ) {
        this.context = associatedContext
    }

    setFromAny(element: any) {
        const {
            identifier,
            contextId,
            contextIds,
            contextIdRights,
            wildart,
            gender,
            age,
            tagid,
            officialGameTag,
            timeStamp,
            updateTimestamp,
            creationDate,
            huntingDistrictId,
            huntingDistrictName,
            huntingDistrictAdministrativeName,
            ageInYears,
            placeOfKilling,
            placeOfKillingLatitude,
            placeOfKillingLongitude,
            // species,
            gameCollectStationId,
            gameCollectStationName,
            weights,
            erlegerId,
            erlegerAnzeigeName,
            hunterLocation,
            erlegeArt,
            erlegeArtTitle,
            eventId,
            eventName,
            shotQuality,
            shotQualityTitle,
            meatQuality,
            meatQualityTitle,
            comment,
            anteMortemInspectionComments,
            postMortemInspectionRequired,
            postMortemInspectionComment,
            unbekanntZuvorBeschossen,
            hasShootPrice,
            shootPrice,
            receiptNo,
            captureLocation,
            currentLocation,
            status,
            statusTitle,
            currentLocationID,
            currentLocationTitle,
            gameCount,
            imageCount,
            locationCoordinates,
            postingAccount,
            plannedUtilization,
            plannedUtilizationDisplay,
            plannedUtilizationDetails,
            reportingIds,
            gameOriginFormData,
            quality,
            hiTierState,
            hiTierResult,
            extra,
            veterinarianOffice,
            huntingOffice,
            pictureURLlinks,
            reportingImages,
            webTSNobject,
            laboratorySamples,
            createdByUserId,
            createdByUserName
        } = element
        // set title if no title is given
        
        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.contextIds = contextIds ? contextIds : this.contextIds
        this.contextIdRights = contextIdRights ? contextIdRights : this.contextIdRights
        this.wildart = wildart ? wildart : this.wildart
        this.gender = gender ? gender : this.gender
        this.age = age ? age : this.age
        this.tagid = tagid ? tagid : this.tagid
        this.officialGameTag = officialGameTag ? officialGameTag : this.officialGameTag
        this.timeStamp = timeStamp ? isDate(timeStamp) ? timeStamp : firestoreTimestampToDate(timeStamp) : this.timeStamp
        this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName
        this.huntingDistrictAdministrativeName = huntingDistrictAdministrativeName ? huntingDistrictAdministrativeName : this.huntingDistrictAdministrativeName
        this.ageInYears = ageInYears ? ageInYears : this.ageInYears
        this.placeOfKilling = placeOfKilling ? placeOfKilling : this.placeOfKilling
        this.placeOfKillingLatitude = placeOfKillingLatitude ? placeOfKillingLatitude : this.placeOfKillingLatitude
        this.placeOfKillingLongitude = placeOfKillingLongitude ? placeOfKillingLongitude : this.placeOfKillingLongitude
        this.gameCollectStationId = gameCollectStationId ? gameCollectStationId : this.gameCollectStationId
        this.gameCollectStationName = gameCollectStationName ? gameCollectStationName : this.gameCollectStationName
        this.weights = weights ? weights : {}
        this.erlegerId = erlegerId ? erlegerId : this.erlegerId
        this.hunterLocation = hunterLocation ? hunterLocation : this.hunterLocation
        this.erlegeArt = erlegeArt ? erlegeArt : this.erlegeArt
        this.eventId = eventId ? eventId : this.eventId
        this.eventName = eventName ? eventName : this.eventName
        this.plannedUtilization = plannedUtilization ? plannedUtilization : this.plannedUtilization
        this.shotQuality = shotQuality ? shotQuality : this.shotQuality
        this.meatQuality = meatQuality ? meatQuality : this.meatQuality
        this.comment = comment ? comment : this.comment
        this.anteMortemInspectionComments = anteMortemInspectionComments ? anteMortemInspectionComments : this.anteMortemInspectionComments
        this.postMortemInspectionRequired = (postMortemInspectionRequired != undefined) ? postMortemInspectionRequired : this.postMortemInspectionRequired
        this.postMortemInspectionComment = postMortemInspectionComment ? postMortemInspectionComment : this.postMortemInspectionComment
        this.unbekanntZuvorBeschossen = (unbekanntZuvorBeschossen != undefined) ? unbekanntZuvorBeschossen : this.unbekanntZuvorBeschossen
        this.hasShootPrice = (hasShootPrice != undefined) ? hasShootPrice : this.hasShootPrice
        this.shootPrice = shootPrice ? shootPrice : this.shootPrice
        this.receiptNo = receiptNo ? receiptNo : this.receiptNo
        this.captureLocation = captureLocation ? captureLocation : this.captureLocation
        this.currentLocation = currentLocation ? currentLocation : this.currentLocation
        this.status = status ? status : this.status
        this.currentLocationID = currentLocationID ? currentLocationID: this.currentLocationID
        this.erlegerAnzeigeName = erlegerAnzeigeName ? erlegerAnzeigeName : this.erlegerAnzeigeName
        this.gameCount = gameCount ? gameCount : this.gameCount
        this.imageCount = imageCount ? imageCount : this.imageCount
        this.locationCoordinates = locationCoordinates ? locationCoordinates : this.locationCoordinates
        this.postingAccount = postingAccount ? postingAccount : this.postingAccount
        this.plannedUtilizationDetails = plannedUtilizationDetails ? plannedUtilizationDetails : this.plannedUtilizationDetails
        this.erlegeArtTitle = erlegeArtTitle ? erlegeArtTitle : this.erlegeArtTitle
        this.shotQualityTitle = shotQualityTitle ? shotQualityTitle : this.shotQualityTitle
        this.meatQualityTitle = meatQualityTitle? meatQualityTitle : this.meatQualityTitle
        this.statusTitle = statusTitle ? statusTitle : this.statusTitle
        this.currentLocationTitle = currentLocationTitle ? currentLocationTitle : this.currentLocationTitle
        this.plannedUtilizationDisplay = plannedUtilizationDisplay ? plannedUtilizationDisplay : this.plannedUtilizationDisplay
        this.reportingIds = reportingIds ? reportingIds : this.reportingIds
        this.gameOriginFormData = gameOriginFormData ? gameOriginFormData : this.gameOriginFormData
        this.quality = quality ? quality : this.quality
        this.hiTierState = hiTierState ? hiTierState : this.hiTierState
        this.hiTierResult = hiTierResult ? hiTierResult : this.hiTierResult
        this.extra = extra ? extra : this.extra
        this.reportingImages = reportingImages ? reportingImages : this.reportingImages
        this.veterinarianOffice = veterinarianOffice ? veterinarianOffice : this.veterinarianOffice
        this.huntingOffice = huntingOffice ? huntingOffice : this.huntingOffice
        this.pictureURLlinks = pictureURLlinks ? pictureURLlinks : this.pictureURLlinks
        this.reportingImages = reportingImages ? reportingImages : this.reportingImages
        this.webTSNobject = webTSNobject ? webTSNobject : this.webTSNobject
        this.laboratorySamples = laboratorySamples ? laboratorySamples : this.laboratorySamples
        this.createdByUserId = createdByUserId ? createdByUserId : this.createdByUserId
        this.createdByUserName = createdByUserName ? createdByUserName : this.createdByUserName
        if (!erlegeArtTitle && !this.erlegeArtTitle && this.erlegeArt) this.erlegeArtTitle = this.getHuntingMethodTitle()
        if (!shotQualityTitle && !this.shotQualityTitle && this.shotQuality) this.shotQualityTitle = this.getShotQualitiesTitle()
        if (!meatQualityTitle && !this.meatQualityTitle && this.meatQuality) this.meatQualityTitle = this.getMeatQualitiesTitle()
        if (!statusTitle && !this.statusTitle && this.status) this.statusTitle = this.getCurrentStatusTitle()
        if (!currentLocationTitle && !this.currentLocationTitle && this.currentLocationID) this.currentLocationTitle = this.getCurrentLocationTitle()
        if (!plannedUtilizationDisplay && !this.plannedUtilizationDisplay && this.plannedUtilization) this.plannedUtilizationDisplay = this.getPlannedUtilizationTitle()
    }

    setTimeStampOrDate(time: any): Date|undefined {
        if (!time) return undefined
        else if (isDate(time)) return time
        else if (isFirebaseTimestamp(time)) return new Date(time.seconds * 1000)
        else return undefined 
    }

    setLocationCoordinates() {

    }

    searchFilter(filter: string): boolean {
        const str = `${this.wildart}${this.huntingDistrictName}${this.tagid}${this.officialGameTag}${this.erlegerAnzeigeName}${this.age}`.toLowerCase()
        return str.includes(filter)
    }

    htmlBottomString(): string|undefined {
        var str = ""
        if (this.ageInYears) str += `${this.ageInYears}, `
        if (this.gender) str += `${this.gender}, `
        if (this.age) str += `${this.age}`
        const strLength = str.length
        if (str.substring(str.length -2, str.length - 1) == ", ") str.slice(str.length -2, str.length - 1)
        if (str[strLength-1] == ",") str.slice(strLength-1)
        return (str == "") ? undefined : str
    }

    htmlErleger() {
        return (this.erlegerAnzeigeName) ? this.erlegerAnzeigeName : undefined
    }

    getSpeciesTitle(): string|undefined {
        if(!this.wildart) return undefined
        const settingRef = NetworkConstants.SETTING_SPECIES
        const setting = this.context?.settingsMap?.get(settingRef)
        if (!this.context || !setting) return this.wildart ? this.wildart : undefined
        const species = setting.values.find(el => el.identifier == this.wildart)
        if (!species) return this.wildart ? this.wildart : undefined
        return species.names?.de ? species.names?.de : this.wildart
    }
    getIconName() {
        if(!this.wildart) return undefined
        const settingRef = NetworkConstants.SETTING_SPECIES
        const setting = this.context?.settingsMap?.get(settingRef)
        if (!this.context || !setting) return undefined
        const species = setting.values.find(el => el.identifier == this.wildart)
        if (!species) return undefined
        return species.iconName
    }
    getMeatQualitiesTitle(): string|undefined {
        if (this.meatQualityTitle) return this.meatQualityTitle
        if (!this.meatQuality) return undefined
        const settingRef = NetworkConstants.SETTING_GR_MEAT_QUALITY
        const setting = this.context?.settingsMap?.get(settingRef)
        if (!this.context || !setting) return this.meatQuality ? this.meatQuality : undefined
        const quality = setting.values.find(el => el.identifier == this.meatQuality)
        if (!quality) return this.meatQuality ? this.meatQuality : undefined
        return quality.title ? quality.title : this.meatQuality ? this.meatQuality : undefined
    }
    getShotQualitiesTitle(): string|undefined {
        if (this.shotQualityTitle) return this.shotQualityTitle
        if (!this.shotQuality) return undefined
        const settingRef = NetworkConstants.SETTING_GR_SHOT_QUALITY
        const setting = this.context?.settingsMap?.get(settingRef)
        if (!this.context || !setting) return this.shotQuality ? this.shotQuality : undefined
        const quality = setting.values.find(el => el.identifier == this.shotQuality)
        if (!quality) return this.shotQuality ? this.shotQuality : undefined
        return quality.title ? quality.title : this.shotQuality ? this.shotQuality : undefined
    }
    // future ... now age is always title... 
    getAgeTitle(): string|undefined {
        return this.age ? this.age : undefined
        // if (!this.age && !this.gender) return undefined
        // if (!this.gender) return this.age ? this.age : undefined
        // const settingRef = NetworkConstants.SETTING_SPECIES
        // const setting = this.context?.settingsMap.get(settingRef)
        // if (!this.context || !setting) return this.age ? this.age : undefined
        // const species = setting.values.find(el => el.identifier == this.wildart)
        // if (!species) return this.age ? this.age : undefined
        // let genderClasses: any; 
        // if (this.gender == GameRecordGender.FEMALE) {
        //     genderClasses = species.ageClassesFemale
        // } else {
        //     genderClasses = species.ageClassesMale
        // }
        // if (!genderClasses) return this.age ? this.age : undefined
        // const {de} = genderClasses

        // return quality.title ? quality.title : this.shotQuality ? this.shotQuality : undefined
    }
    getCurrentLocationTitle(): string|undefined {
        if (this.currentLocationTitle) return this.currentLocationTitle
        if (!this.currentLocationID) return undefined 
        const settingRef = NetworkConstants.SETTING_GR_LOCATION
        const setting = this.context?.settingsMap?.get(settingRef)
        if (!this.context || !setting) return this.currentLocationID
        const location = setting.values.find(el => el.identifier == this.currentLocationID)
        if(!location) return this.currentLocationID
        return location.title ? location.title : this.currentLocationID
    }
    getCurrentStatusTitle(): string|undefined {
        if (!this.status) return undefined
        const settingRef = NetworkConstants.SETTING_GR_STATUS
        const setting = this.context?.settingsMap?.get(settingRef)
        if (!this.context || !setting) return this.status
        const status = setting.values.find(el => el.identifier == this.currentLocationID)
        if(!status) return this.status
        return status.title ? status.title : this.currentLocationID
    }
    getHuntingMethodTitle(): string|undefined {
        if (this.erlegeArtTitle) return this.erlegeArtTitle
        if (!this.erlegeArt) return undefined
        const settingRef = NetworkConstants.SETTING_HUNTING_METHODS
        const setting = this.context?.settingsMap?.get(settingRef)
        if (!this.context || !setting) return this.erlegeArt
        const set = setting.values.find(el => el.identifier == this.erlegeArt)
        if(!set) return this.erlegeArt
        return set.title ? set.title : this.erlegeArt
    }

    getPlannedUtilizationTitle() {
        if (this.plannedUtilizationDisplay) return this.plannedUtilizationDisplay
        if(!this.plannedUtilization) return undefined
        const settingRef = NetworkConstants.SETTING_UTILIZATION_OPTION
        const setting = this.context?.settingsMap?.get(settingRef)
        if (!this.context || !setting) return this.plannedUtilization
        const set = setting.values.find(el => el.identifier == this.plannedUtilization)
        if(!set) return this.plannedUtilization
        return set.title ? set.title : this.plannedUtilization
    }

    getFeature(strUnkown: string): any|undefined {
        const location = this.locationCoordinates ? this.locationCoordinates 
            : this.placeOfKilling?.location ? this.placeOfKilling?.location 
            : null
        if (!location) return undefined
        let {identifier, 
            erlegerAnzeigeName, 
            timeStamp,
        } = this
        let wildart = this.getSpeciesTitle()
        let locationTitle = this.getCurrentLocationTitle()
        let status = this.getCurrentStatusTitle()
        let erlegeArt = this.getHuntingMethodTitle()
        let icon = this.getIconName()
        if (!icon) {
            icon = 'pin'
        }
        return {
            type: "Feature",
            properties: {
                identifier,
                erlegerAnzeigeName, 
                wildart: wildart ? wildart : strUnkown,
                // for icon display
                icon: icon,
                type: wildart ? wildart : strUnkown,
                status: status ? status : strUnkown,
                currentLocationID: locationTitle ? locationTitle : strUnkown,
                timeStamp,
                erlegeArt: erlegeArt ? erlegeArt : strUnkown,
            },
            geometry: {
            type: 'Point',
            coordinates: [location.longitude, location.latitude]
            }
        }
    }

    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key 
     */
    replacerFn(key: string) {
        if (key == "context") return false
        else return true
    }    
}